import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { useAuthStore } from '@/stores/auth.store'

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
})

function AuthLayout() {
  const navigate = useNavigate()
  const auth = useAuthStore()

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      void navigate({ to: '/' })
    }
  }, [auth.isAuthenticated, auth.user, navigate])

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[url('/images/default-background.jpg')] bg-cover bg-center bg-no-repeat px-4 py-6">
      <div className="z-10 flex w-full max-w-[438px] flex-col items-center justify-center gap-6 rounded-xl bg-white p-5 sm:rounded-2xl sm:p-8">
        <img alt="logo" className="h-14 sm:h-16" src="logos/massilia-logo.png" />
        <Outlet />
      </div>
    </div>
  )
}
